import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

const ValidationError = ({ error }) => (
  <div className="box" style={{ backgroundColor: '#e53935' }}>
    <div className="col-sm-12">
      <Typography variant="body2" style={{ color: '#fff', fontWeight: '500' }}>{error}</Typography>
    </div>
  </div>
);

ValidationError.propTypes = {
  error: PropTypes.string.isRequired,
};

export default ValidationError;


// WEBPACK FOOTER //
// ./src/components/budget/types/ValidationError.js